import { render } from "./index.vue?vue&type=template&id=2197dc78"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/messages/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2197dc78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2197dc78', __exports__)) {
    console.log('reload')
    api.reload('2197dc78', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2197dc78", () => {
    console.log('re-render')
    api.rerender('2197dc78', render)
  })

}


export default __exports__